// Account fit
export enum ACCOUNT_FIT_BUCKETS {
  UNKNOWN = 'Unknown',
  POOR = 'Poor',
  FAIR = 'Fair',
  GOOD = 'Good',
  EXCELLENT = 'Excellent'
}

export const bucketFitScore = (score: number | undefined) => {
  if (!score) {
    return ACCOUNT_FIT_BUCKETS.UNKNOWN
  } else if (score < 0.15) {
    return ACCOUNT_FIT_BUCKETS.POOR
  } else if (score < 0.5) {
    return ACCOUNT_FIT_BUCKETS.FAIR
  } else if (score < 0.85) {
    return ACCOUNT_FIT_BUCKETS.GOOD
  } else {
    return ACCOUNT_FIT_BUCKETS.EXCELLENT
  }
}

// Engagement scores
export enum ENGAGEMENT_BUCKETS {
  POOR = 'Not engaged',
  FAIR = 'Engaged',
  GOOD = 'Very engaged',
  EXCELLENT = 'Extremely engaged'
}

export const bucketEngagementScore = (score: number | undefined) => {
  if (!score) {
    return ENGAGEMENT_BUCKETS.POOR
  } else if (score < 3) {
    return ENGAGEMENT_BUCKETS.POOR
  } else if (score < 4) {
    return ENGAGEMENT_BUCKETS.FAIR
  } else if (score < 5) {
    return ENGAGEMENT_BUCKETS.GOOD
  } else {
    return ENGAGEMENT_BUCKETS.EXCELLENT
  }
}

// Account recommendations
export enum ACCOUNT_RECOMMENDATION {
  YES = 'Yes',
  MAYBE = 'Maybe',
  NO = 'No',
  UNKNOWN = 'Unknown'
}

export const bucketRecommendation = (rec: number | undefined) => {
  if (!rec) {
    return ACCOUNT_RECOMMENDATION.UNKNOWN
  } else if (rec > 67) {
    return ACCOUNT_RECOMMENDATION.YES
  } else if (rec >= 33) {
    return ACCOUNT_RECOMMENDATION.MAYBE
  } else {
    return ACCOUNT_RECOMMENDATION.NO
  }
}